import { render, staticRenderFns } from "./reainfadi3.vue?vue&type=template&id=1872758c&scoped=true"
import script from "./reainfadi3.vue?vue&type=script&lang=js"
export * from "./reainfadi3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1872758c",
  null
  
)

export default component.exports